/* v2 add-ons for the bag drawer: free-shipping meter and a one-tap "make it 2 jars" upgrade.
   Runs after hearsay.js renders #CartItems, so the original drawer code stays untouched. */
(function () {
  'use strict';
  var H = window.Hearsay || {};
  var FREE = Number(H.freeShipCents) || 0;
  var SHIP = Number(H.shipFeeCents) || 0;
  var box, busy = false, pending = false;

  function money(c) {
    var f = H.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2));
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function meterHtml(total) {
    if (!FREE) return '';
    var pct = Math.min(100, Math.round(total * 100 / FREE));
    var msg = total >= FREE
      ? '<b>Free US shipping</b> is on this order.'
      : money(FREE - total) + ' away from <b>free US shipping</b>.';
    return '<div class="ship-meter" data-v2><p>' + msg + '</p><div class="ship-meter__bar"><span style="width:' + pct + '%"></span></div></div>';
  }

  function enhance() {
    if (busy) { pending = true; return; }
    busy = true;
    fetch(H.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        box.querySelectorAll('[data-v2]').forEach(function (n) { n.remove(); });
        if (!cart.item_count) return;
        box.insertAdjacentHTML('afterbegin', meterHtml(cart.total_price));
        // One upgrade line only: a single item, quantity 1, with a bigger bundle available.
        if (cart.items.length !== 1 || cart.items[0].quantity !== 1) return;
        var item = cart.items[0];
        return fetch('/products/' + item.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var i = p.variants.findIndex(function (v) { return v.id === item.variant_id; });
          var next = p.variants[i + 1];
          if (i < 0 || !next || !next.available) return;
          // v6.12: say what the bigger bundle really adds once shipping turns free, and the price per jar.
          var extra = next.price - item.final_price;
          var freed = FREE && SHIP && cart.total_price < FREE && cart.total_price + extra >= FREE && extra > SHIP;
          var jars = parseInt(next.title, 10) || 0;
          var sub = freed ? 'Shipping becomes free, so your total goes up just ' + money(extra - SHIP) : '';
          if (jars > 1) sub += (sub ? ' · ' : '') + money(Math.round(next.price / jars)) + ' a jar';
          box.insertAdjacentHTML('beforeend',
            '<button type="button" class="upgrade" data-v2 data-upgrade="' + next.id + '" data-key="' + esc(item.key) + '">' +
            '<span>Make it ' + esc(next.title) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span><b>+' + money(extra) + '</b></button>');
        });
      })
      .catch(function () {})
      .finally(function () { busy = false; if (pending) { pending = false; enhance(); } });
  }

  function upgrade(btn) {
    btn.disabled = true;
    var key = btn.getAttribute('data-key');
    fetch(H.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () {
        return fetch(H.routes.cartAdd + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-upgrade')), quantity: 1 }] })
        });
      })
      .then(function () { return fetch(H.routes.cart + '.js', { headers: { Accept: 'application/json' } }); })
      .then(function () {
        // Let hearsay.js re-render the drawer through its own open handler.
        var opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click(); else window.location.reload();
      })
      .catch(function () { btn.disabled = false; });
  }

  function init() {
    box = document.getElementById('CartItems');
    if (!box) return;
    new MutationObserver(function (muts) {
      var external = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) { return !(n.nodeType === 1 && n.hasAttribute('data-v2')); });
      });
      if (external) enhance();
    }).observe(box, { childList: true });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-upgrade]');
      if (b) upgrade(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
